<div class="folder-item" (click)="onClickRow()" [id]="itemID">
  <ion-checkbox class="folder-item-checkbox" [(ngModel)]="folderItem.selected" (click)="$event.stopPropagation()" (ionChange)="onFolderSelect()"></ion-checkbox>
  <div class="folder-icon" [class.folder-checked]="folderItem?.attributes?.document_review === 1">
    <span *ngIf="folderItem?.attributes?.document_review === 1" class="visually-hidden">{{ 'CONTENT.Document_Review' | translate }}</span>
  </div>
  <span class="folder-item-text">{{ folderItem | translateBy: 'title' }}</span>
</div>
